import LTR from "@brand-icons/ploom/filter/filter-ltr.svg";
import RTL from "@brand-icons/ploom/filter/filter-rtl.svg";

import { iconFactory } from "../iconFactory";

export const FilterIcon = iconFactory("FilterIcon", LTR, RTL);
